/**
 * @generated SignedSource<<451133c0edec94c76d51ef62fb88c5cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventGuestSendInvitationInput = {
  eventId: string;
  eventGuestId: string;
};
export type eventGuestSendInvitationMutation$variables = {
  input: EventGuestSendInvitationInput;
};
export type eventGuestSendInvitationMutation$data = {
  readonly sendEventGuestInvitation: {
    readonly success: boolean;
    readonly message: string;
  };
};
export type eventGuestSendInvitationMutation = {
  variables: eventGuestSendInvitationMutation$variables;
  response: eventGuestSendInvitationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventGuestSendInvitationPayload",
    "kind": "LinkedField",
    "name": "sendEventGuestInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "eventGuestSendInvitationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "eventGuestSendInvitationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a5f4786015f085cce389e1b0d15f57cd",
    "id": null,
    "metadata": {},
    "name": "eventGuestSendInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation eventGuestSendInvitationMutation(\n  $input: EventGuestSendInvitationInput!\n) {\n  sendEventGuestInvitation(input: $input) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "67b2e3b3aa5d4d1780c17baf6e099252";

export default node;
